<div class="container-fluid p-4 rounded shadow my-5" id="filtersBox">
    <div class="d-flex justify-content-center">
      <h3 class="badge lime-green-button1 text-white rounded-pill p-4">
        Lokalno dogajanje
      </h3>
    </div> 
</div>

<div class="text-center m-0">
    <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
  </div>

  <!-- Event Row -->
  <div class="container my-5">
    <app-event-list [allEvents]="allEvents" [allFarms]="allFarms" [onAdminPage]="false"></app-event-list>

  <!-- Calendar Row -->
  <div class="container my-5">
    <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
      <fa-icon class="me-2 fa-lg" [icon]="faCalendar"></fa-icon>Koledar ponudbe in dogodkov</h3>
    <app-full-calendar [onMarketPage]="isOnMarketPage"></app-full-calendar>
  </div>